exports = module.exports = require("../../../node_modules/_css-loader@1.0.1@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-79455204] .avue-crud__pagination .el-pagination {\n  display: inline-block !important;\n}\n[data-v-79455204] .el-date-editor--datetimerange.el-input__inner {\n  max-width: 350px !important;\n}", ""]);

// exports
